<kendo-appbar class="navbar navbar-expand-lg navbar-light bg-light fixed-top text-nowrap" position="top">
  <kendo-appbar-section>
    <button kendoButton fillMode="flat" class="overflow-button" #anchorNav (click)="togglePopup('nav')">
      <img [src]="'/assets/menu/'+ theme +'/enterprise-home-icon.svg'" class="menu_logo" />
    </button>
    @if (activePopup === 'nav') {
      <kendo-popup class="nav-popup" [anchor]="anchorNav.element" style="z-index: 1000;">
        <div class="content">
          <div style="width: 220px;">
            <!-- <div class="row pb-5" (click)="togglePopup('nav')">
            <span>
              <img [src]="'/assets/menu/'+ theme +'/enterprise-home-icon.svg'" class="menu_logo" />
            </span>
            <span class="ml-2">
              <a class="navbar-brand brandName">Barcloud NG</a>
            </span>
          </div> -->
          @if (_isAsset && _inAssetBase) {
            <div class="py-2 cursor-pointer" [class.active]="base != 'stock'" (click)="_mainSwitch('asset')">
              <div class="">
                <span>
                  <img [src]="'/assets/menu/'+ theme +'/stock-file-icon.svg'" alt="vxcvxcv" class="menuIcon mr-2 ml-3">
                </span>
                @if (!_currentUser.isEnterprise) {
                  <span>Barcloud NG Asset</span>
                }
                @if (_currentUser.isEnterprise) {
                  <span>Enterprise Asset</span>
                }
              </div>
            </div>
          }
          @if (_isAsset && _inAssetBase && _isStock && _inStockBase) {
            <div class="hr"></div>
          }
          @if (_isStock && _inStockBase) {
            <div class="py-2 cursor-pointer" [class.active]="base == 'stock'" (click)="_mainSwitch('stock')">
              <div class="">
                <span>
                  <img [src]="'/assets/menu/'+ theme +'/stock-file-icon.svg'" alt="vxcvxcv" class="menuIcon mr-2 ml-3">
                </span>
                @if (!_currentUser.isEnterprise) {
                  <span>Barcloud NG Stock</span>
                }
                @if (_currentUser.isEnterprise) {
                  <span>Enterprise Stock</span>
                }
              </div>
            </div>
          }
          @if (_isShopping) {
            <div class="hr"></div>
          }
          @if (_isShopping) {
            <div class="py-2 cursor-pointer" (click)="_mainSwitch('ShoppingCart')">
              <div class="">
                <span>
                  <img [src]="'/assets/menu/'+ theme +'/stock-file-icon.svg'" alt="vxcvxcv" class="menuIcon mr-2 ml-3">
                </span>
                <span>Shopping Cart</span>
              </div>
            </div>
          }
        </div>
      </div>
    </kendo-popup>
  }
</kendo-appbar-section>

<kendo-appbar-section>
  <a class="navbar-brand brandName" id="brandNameLink" href="/">
    <span id="brandname">{{ _isEnterprise ? "Enterprise" : "Barcloud NG"}} {{ base == 'stock' ? "Stock" : "Asset"}}</span>
  </a>
</kendo-appbar-section>
<kendo-appbar-spacer width="32px"></kendo-appbar-spacer>

<kendo-appbar-spacer></kendo-appbar-spacer>

<kendo-appbar-section>
  <div class="themeDropdown">
    <span class="theme-mode" (click)="toggleTheme()">Dark Mode</span>
    <kendo-switch
      [onLabel]="'ON'"
      [offLabel]="'OFF'"
      trackRounded="full"
      thumbRounded="full"
      [(ngModel)]="_themeToggleChecked"
      [ngModelOptions]="{standalone: true}"
      (valueChange)="changeTheme($event)">
    </kendo-switch>
  </div>

  <div class="nav-item dropdown">
    <div class="nav-link" #anchorFav (click)="togglePopup('fav')">
      <img [src]="'/assets/menu/'+ theme +'/stock-favorite-icon.svg'" class="topRightMenuIcon" /><br />
      <span class="bottomLabel_top">Favorites</span>
    </div>
    @if (activePopup === 'fav') {
      <kendo-popup id="div_mnuFavorites" [anchor]="anchorFav" style="z-index: 1000;">
        <div class="col-12">
          <div class="row newNav">
            <div class="col-12">
              <h2 class="content_tab_title">
                <span>
                  <img [src]="'/assets/menu/'+ theme +'/stock-favorite-icon.svg'" class="topright_menu_title_icon" />
                </span>
                My Favorites
              </h2>
            </div>
          </div>
          <div class="row menucontentdiv newNav">
            <div class="col-12">
              <div class="row">
                @for (item of favoritePages; track item.category || $index) {
                  <div class="col-10 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <div class="row">
                      <div class="col-12 content_title">{{item.category}}</div>
                      @for (value of item.values; track value.url || value.label || $index) {
                        <div class="col-12 element_item_link">
                          <a href="javascript:void(0)" class="menulink_style">
                            <span class="image_span">
                              <img class="" [src]="'/assets/menu/'+ theme +'/circle-icon_new.svg'" />
                            </span>
                            <span class="p_span_favorites" (click)="_navigate(value.page, value.category)">
                              {{ _getPageDescription(value.page, value.category) }}
                            </span>
                          </a>
                          <div class="sub_topright_menu_links">
                            @if (value.category == 'Files' || value.category == 'Orders' || value.category == 'Reports') {
                              <a (click)="_openForm(value.page)" class="">
                                <img class="" [src]="'/assets/menu/'+ theme +'/stock-add-new-icon.svg'" />
                              </a>
                            }
                            <a (click)="_favorite(value)" class="">
                              <img class="" [src]="'/assets/menu/'+ theme +'/asset-add-favorite-icon-hover_new.svg'" />
                            </a>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </kendo-popup>
    }
  </div>

  @if (_currentUser && !_currentUser.isEnterprise && isAdmin) {
    <div class="nav-item dropdown">
      <div class="nav-link" #anchorAdmin (click)="togglePopup('admin')">
        <img [src]="'/assets/menu/'+ theme +'/admin-icon-new.svg'" class="topRightMenuIcon" /><br />
        <span class="bottomLabel_top">Admin</span>
      </div>
      @if (activePopup === 'admin') {
        <kendo-popup id="div_admin" [anchor]="anchorAdmin" style="z-index: 1000;">
          <div class="col-12">
            <div class="row menucontentdiv">
              <div class="col-12">
                <admin-section [base]="base" (click)="togglePopup('admin')"></admin-section>
              </div>
            </div>
          </div>
        </kendo-popup>
      }
    </div>
  }

  <div class="nav-item dropdown">
    <div class="nav-link" #anchorHelp (click)="togglePopup('help')">
      <img [src]="'/assets/menu/'+ theme +'/stock-wiki-icon.svg'" class="topRightMenuIcon" /><br />
      <span class="bottomLabel_top">Help</span>
    </div>
    @if (activePopup === 'help') {
      <kendo-popup id="div_ListSupport" [anchor]="anchorHelp" style="z-index: 1000;">
        <div class="col-12">
          <div class="row newNav">
            <div class="col-12">
              <h2 class="content_tab_title">
                <span>
                  <img [src]="'/assets/menu/'+ theme +'/stock-wiki-icon.svg'" class="topright_menu_title_icon_wiki" />
                </span>
                Help
              </h2>
            </div>
          </div>
          <div class="row menucontentdiv newNav">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 menulink_help">
                      <a [href]="helpUrls.wikiUrl" target="_blank" rel="noopener noreferrer" class="menulink_help_item">
                        <span><img class="" [src]="'/assets/menu/'+ theme +'/circle-icon_new.svg'" /></span>
                        Wiki
                      </a>
                    </div>
                    <div class="col-12 menulink_help">
                      <a [href]="helpUrls.contactSupportUrl" target="_blank" rel="noopener noreferrer"
                        class="menulink_help_item">
                        <span>
                          <img class="" [src]="'/assets/menu/'+ theme +'/circle-icon_new.svg'" />
                        </span>
                        Contact Support
                      </a>
                    </div>
                    <div class="col-12 menulink_help">
                      <a [href]="helpUrls.scheduleTrainingUrl"
                        target="_blank" rel="noopener noreferrer" class="menulink_help_item">
                        <span>
                          <img class="" [src]="'/assets/menu/'+ theme +'/circle-icon_new.svg'" />
                        </span>
                        Schedule Training
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </kendo-popup>
    }
  </div>

  <div class="nav-item dropdown">
    <div class="nav-link d-flex align-items-center" #anchorSite style="font-size: small;" (click)="togglePopup('site')">
      <asap-users-avatar [icon]="_userProfilePic??'/assets/menu/'+ theme +'/profile-icon.svg'" [ngClass]="'admin_image_section'">
      </asap-users-avatar>
      <div class="text-start">
        <span class="bold">{{_semiUserName}}</span>
        @if (_isMultiSite && !_isEnterprise) {
          <br />
        }
        @if (_isMultiSite && !_isEnterprise) {
          <span class="grey">Site: {{_currentSiteName}}</span>
        }
      </div>
    </div>
    @if (activePopup === 'site') {
      <kendo-popup [anchor]="anchorSite" style="z-index: 1000; max-width: 333px; margin-left: -2px">
        <div class="col-12">
          <div class="row newNav">
            <div class="col-12">
              <!-- <div class="asap-users-avatar-icon">
              <img appImagePopup [ngClass]="'admin_image_section'" [src]="_userProfilePic??'/assets/menu/'+ theme +'/profile-icon.svg'" onerror="this.src='/assets/menu/enterprise/profile-icon.svg'" />
            </div> -->
            <div class="admin_text_section">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-12 special_admin_padding">
                        <div class="row">
                          <div class="col-12 pt-3 pb-2">
                            <div class="asap-users-avatar-icon">
                              <img appImagePopup [ngClass]="'admin_image_section me-2'" [src]="_userProfilePic ?? '/assets/menu/'+ theme +'/profile-icon.svg'" onerror="this.src='/assets/menu/enterprise/profile-icon.svg'" />
                            </div>
                            <p class="admin_text_section_txt text-wrap admin_section_title mt-1">
                              {{_userFullName}}
                            </p>
                            <p class="admin_text_section_txt">
                              {{_email}}
                            </p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <hr class="mb-2 mt-0 w-75" />
                          </div>
                        </div>
                        @if (_isMultiSite && !_isEnterprise) {
                          <div class="row margin_top_5 mb-2">
                            <div class="col-12">
                              <p class="admin_text_section_txt admin_section_title">
                                Switch Sites
                              </p>
                              <kendo-combobox id="changesite_dropDown"
                                [data]="_userSites"
                                [(ngModel)]="selectedSite" [ngModelOptions]="{standalone: true}"
                                [textField]="'code'"
                                [valueField]="'id'"
                                (valueChange)="_switchSites($event)"
                                [clearButton]="false">
                              </kendo-combobox>
                            </div>
                          </div>
                        }
                        <div class="row">
                          <div class="col-12">
                            <a class="admin_text_section_txt admin_section_title" [routerLink]="['/account/change-password']" [queryParams]="{ base: base }">
                              change password
                            </a>
                          </div>
                        </div>
                        @if (!_isEnterprise && sitesEnabled()) {
                          <div class="row">
                            <div class="col-12">
                              <a class="admin_text_section_txt admin_section_title" [routerLink]="['/common/'+base+'/sites']">
                                Sites
                              </a>
                            </div>
                          </div>
                        }
                        <div class="row">
                          <div class="col-12">
                            <a class="admin_text_section_txt admin_section_title logout_link" (click)="logout()">
                              log out
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </kendo-popup>
  }
</div>


</kendo-appbar-section>
</kendo-appbar>
